<template>
  <d-container fluid class="main-content-container px-4">
    <div class="page-header row no-gutters py-4">
      <div class="col-12 col-sm-4 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle">Airports</span>
        <h3 class="page-title">New Airport</h3>
      </div>
    </div>

    <d-card class="card-small">
      <d-list-group flush>
        <d-list-group-item class="p-3">
          <d-row>
            <d-col lg="9">
              <d-form id="create-airport-form">
                <div class="form-group">
                  <label for="name">IATA airport code</label>
                  <input
                    id="name"
                    class="form-control"
                    v-model.trim="fields.iata"
                    @blur="validateIataInput"
                    :class="{ 'is-invalid': iataAirportCodeErrors.length > 0 }"
                  />

                  <div v-if="iataAirportCodeErrors.length > 0">
                    <d-form-invalid-feedback
                      v-for="(error, index) in iataAirportCodeErrors"
                      :key="index"
                    >
                      {{ error }}
                    </d-form-invalid-feedback>
                  </div>
                </div>

                <!-- TODO: add form validation on blur -->
                <div class="form-group">
                  <v-multi-language
                    label="Name"
                    v-model="fields.name"
                    :class="{ 'is-invalid': hasError('name') }"
                  />
                  <!-- TODO: show generated error messages here -->
                  <span class="invalid-feedback" v-if="hasError('name')">{{
                    getError("name")
                  }}</span>
                </div>

                <template v-for="(terminal, i) in fields.terminals">
                  <div class="form-group" :key="'terminal-' + i">
                    <label for="name">Terminal name</label>

                    <d-input-group>
                      <input
                        v-model.trim="fields.terminals[i]"
                        class="form-control"
                        @blur="validateTerminalInput(fields.terminals[i])"
                      />

                      <d-input-group-addon append v-if="i > 0">
                        <d-button class="btn-white" @click="onRemoveTerminal(i)"
                          >-</d-button
                        >
                      </d-input-group-addon>

                      <d-input-group-addon
                        append
                        v-if="i === fields.terminals.length - 1"
                      >
                        <d-button theme="primary" @click="onAddTerminal"
                          >+</d-button
                        >
                      </d-input-group-addon>
                    </d-input-group>

                    <div v-if="terminalErrors.length > 0">
                      <d-form-invalid-feedback
                        v-for="(error, index) in terminalErrors"
                        :key="index"
                      >
                        {{ error }}
                      </d-form-invalid-feedback>
                    </div>
                  </div>
                </template>

                <h5>Address</h5>
                <div class="form-group">
                  <label for="street">Street</label>
                  <input
                    id="name"
                    class="form-control"
                    v-model.trim="fields.address.street"
                    @blur="validateStreetInput"
                    :class="{ 'is-invalid': streetErrors.length > 0 }"
                  />
                  <div v-if="streetErrors.length > 0">
                    <d-form-invalid-feedback
                      v-for="(error, index) in streetErrors"
                      :key="index"
                    >
                      {{ error }}
                    </d-form-invalid-feedback>
                  </div>
                </div>
                <d-form-row>
                  <d-col md="6" class="form-group">
                    <label for="zip_code">ZIP code</label>
                    <input
                      id="zip_code"
                      v-model.trim="fields.address.zipCode"
                      autocomplete="off"
                      class="form-control"
                      :class="{ 'is-invalid': zipCodeErrors.length > 0 }"
                      @blur="validateZipCodeInput"
                    />
                    <div v-if="zipCodeErrors.length > 0">
                      <d-form-invalid-feedback
                        v-for="(error, index) in zipCodeErrors"
                        :key="index"
                      >
                        {{ error }}
                      </d-form-invalid-feedback>
                    </div>
                  </d-col>

                  <d-col md="6">
                    <label for="city">City</label>
                    <input
                      id="city"
                      v-model.trim="fields.address.city"
                      autocomplete="off"
                      class="form-control"
                      :class="{ 'is-invalid': cityErrors.length > 0 }"
                      @blur="validateCityInput"
                    />
                    <div v-if="cityErrors.length > 0">
                      <d-form-invalid-feedback
                        v-for="(error, index) in cityErrors"
                        :key="index"
                      >
                        {{ error }}
                      </d-form-invalid-feedback>
                    </div>
                  </d-col>
                </d-form-row>

                <div class="form-group">
                  <label for="country">Country</label>
                  <v-country-select
                    ref="countrySelect"
                    id="country"
                    @input="validateCountryInput"
                    v-model="fields.address.country"
                    autocomplete="off"
                    :class="{ 'is-invalid': countryErrors.length > 0 }"
                  />
                  <div v-if="countryErrors.length > 0">
                    <d-form-invalid-feedback
                      v-for="(error, index) in countryErrors"
                      :key="index"
                    >
                      {{ error }}
                    </d-form-invalid-feedback>
                  </div>
                </div>

                <div class="form-group">
                  <v-coordinates
                    :address="fields.address"
                    @changed="onGetCoordinates"
                  ></v-coordinates>
                </div>

                <d-alert theme="warning" show v-if="submitted && !success">
                  <span>Airport is NOT saved</span>
                </d-alert>

                <d-alert theme="success" show v-if="submitted && success">
                  <span>Airport is successfully saved</span>
                </d-alert>

                <d-button type="submit" @click="onSubmit" :disabled="submitting"
                  >Create Airport</d-button
                >
              </d-form>
            </d-col>
          </d-row>
        </d-list-group-item>
      </d-list-group>
    </d-card>
  </d-container>
</template>

<script>
function onlyContainsLetters(str) {
  return /^[A-Za-z]+$/.test(str) == true;
}

function containsUppercase(str) {
  return /^[A-Z]+$/.test(str);
}

export default {
  data: function() {
    return {
      iataAirportCodeErrors: [] /* Recently added */,
      terminalErrors: [] /* Recently added */,
      streetErrors: [] /* Recently added */,
      zipCodeErrors: [] /* Recently added */,
      cityErrors: [] /* Recently added */,
      countryErrors: [] /* Recently added */,
      submitting: false,
      submitted: false,
      success: false,
      errors: [],
      fields: {
        iata: "",
        name: [],
        terminals: [""],
        latitude: "",
        longitude: "",
        address: {
          street: "",
          zipCode: "",
          city: "",
          country: ""
        }
      }
    };
  },
  methods: {
    hasError: function(field) {
      return this.errors.find(error => error.field === field);
    },

    getError: function(field) {
      return this.errors.find(error => error.field === field).message;
    },

    onAddTerminal: function(event) {
      event.preventDefault();

      this.fields.terminals.push("");
    },

    onRemoveTerminal: function(index) {
      event.preventDefault();

      this.fields.terminals.splice(index, 1);
    },

    onGetCoordinates: function(lat, long) {
      this.fields.latitude = lat;
      this.fields.longitude = long;
    },

    onSubmit: async function(event) {
      event.preventDefault();
      this.validateIataInput();
      this.validateTerminalInput();
      this.validateStreetInput();
      this.validateZipCodeInput();
      this.validateCityInput();
      this.validateCountryInput();

      const terminals = [];
      const name = [];

      this.fields.terminals.forEach(terminal => {
        if (!terminal.length) {
          return;
        }

        terminals.push(terminal);
      });

      Object.entries(this.fields.name).forEach(([language, text]) => {
        if (!text.length) {
          return;
        }

        name.push({
          language: language,
          text: text
        });
      });

      this.submitting = true;
      this.submitted = false;
      this.errors = [];

      const data = await this.$apollo.mutate({
        mutation: require("../../graphql/CreateAirport.gql"),
        variables: {
          iata: this.fields.iata,
          name: name,
          terminals: terminals,
          location: {
            address: this.fields.address,
            latitude: this.fields.latitude,
            longitude: this.fields.longitude
          }
        }
      });

      this.submitting = false;
      this.submitted = true;
      this.success = data.data.createAirport.success;

      if (this.success) {
        this.$router.push({
          name: "airports.single",
          params: {
            id: data.data.createAirport.airport.id
          }
        });
      } else {
        this.errors = data.data.createAirport.errors;
      }
    },
    validateIataInput: function() {
      this.iataAirportCodeErrors = [];
      if (this.fields.iata.length !== 3) {
        this.iataAirportCodeErrors.push(
          "IATA airport code must be 3 characters long."
        );
      }
      if (!onlyContainsLetters(this.fields.iata)) {
        this.iataAirportCodeErrors.push("IATA should only contain letters.");
      }
      if (!containsUppercase(this.fields.iata)) {
        this.iataAirportCodeErrors.push("IATA should be in uppercase.");
      }
      console.log("iata values:");
      console.log(this.iataAirportCodeErrors);
    },
    validateTerminalInput: function(terminal) {
      this.terminalErrors = [];
    },
    validateStreetInput: function() {
      this.streetErrors = [];
      if (!this.fields.address.street) {
        this.streetErrors.push("Street cannot be empty.");
      }
    },
    validateZipCodeInput: function() {
      this.zipCodeErrors = [];
      if (!this.fields.address.zipCode) {
        this.zipCodeErrors.push("ZIP code cannot be empty.");
      }
    },
    validateCityInput: function() {
      this.cityErrors = [];
      if (!this.fields.address.city) {
        this.cityErrors.push("City cannot be empty.");
      }
    },
    validateCountryInput: function() {
      this.countryErrors = [];
      if (!this.fields.address.country) {
        this.countryErrors.push("Country cannot be empty.");
      }
    }
  }
};
</script>
